export default "__VITE_ASSET__BJ2TAk$S__"